module.exports = require('./divide');
